import { useContext } from "react";
import { AvisConstants } from "../../../../../data/avisConstants";
import { CreationRightsHolderInfoBase } from "../../../../../generated/data-contracts";
import { CreationType, ITaggedColumnConfig } from "../../../../../models";
import { AvisSection } from "../../../../shared/components/form";
import { AvisSimpleTable } from "../../../../shared/components/table";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface ICreationRightsHoldersProps {
  creationType: CreationType;
  data: CreationRightsHolderInfoBase[] | undefined;
}

export function CreationRightsHolders(
  props: Readonly<ICreationRightsHoldersProps>,
) {
  const { res } = useContext(AvisContext);
  const { data, creationType } = props;

  const columnMetadata: ITaggedColumnConfig<CreationType>[] = [
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "String",
      name: "fullName",
      translation: res("authors_Creation_Section_RHs_column_FullName"),
      tags: ["M", "AV", "H", "PPI", "V"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "String",
      name: "creationRoleName",
      translation: res("authors_Creation_Section_RHs_column_RoleName"),
      tags: ["M", "AV", "H", "PPI", "V"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "String",
      name: "ipiNumber",
      translation: res("authors_Creation_Section_RHs_column_IPINr"),
      tags: ["M", "AV", "H", "PPI", "V"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "publicPerformance",
      translation: res("authors_Creation_Section_RHs_column_Peroformance"),
      tags: ["M", "H"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "reproductionRights",
      translation: res("authors_Creation_Section_RHs_column_Rights"),
      tags: ["M", "H", "V"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "royalties",
      translation: res("authors_Creation_Section_RHs_column_Royalties"),
      tags: ["AV", "PPI", "V"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "publicLending",
      translation: res("authors_Creation_Section_RHs_column_PublicLending"),
      tags: ["AV"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "tv",
      translation: res("authors_Creation_Section_RHs_column_TV"),
      tags: ["AV"],
    },
    {
      metadata: AvisConstants.table_default_column_metadata,
      type: "Decimal",
      name: "cable",
      translation: res("authors_Creation_Section_RHs_column_Cable"),
      tags: ["AV"],
    },
  ];
  const getDefaultColumnWidths = (
    creationType: CreationType,
  ): number[] | undefined => {
    switch (creationType) {
      case "M":
      case "H":
      case "V":
        return [30, 20, 12, 18, 20];
      case "AV":
        return [30, 20, 11, 11, 14, 7, 7];
      case "PPI":
        return [30, 30, 20, 20];
    }
  };
  if (!data) return; //Do not draw section if is not defined even []

  const columDefFilteredByType = columnMetadata.filter(
    (cd) => cd.tags && cd.tags.indexOf(creationType) > -1,
  );

  return (
    <AvisSection
      collapsable
      expanded
      title={res("authors_Creation_Section_RHs_Title")}
      textToDisplayKey="portal_RH_CreationCard_RH"
    >
      <AvisSimpleTable<CreationRightsHolderInfoBase>
        columnMetadata={columDefFilteredByType}
        data={data}
        columnWidths={getDefaultColumnWidths(creationType)}
      />
    </AvisSection>
  );
}
